import React from 'react'
import Panel from 'muicss/lib/react/panel'
import { connect } from 'react-redux'
import RaisedButton from 'material-ui/RaisedButton'
import Col from 'muicss/lib/react/col'
import Row from 'muicss/lib/react/row'
import { push } from 'react-router-redux'
import FinishGif from '../win_gif.gif'
import { selectCampaign } from '../../../actions'
import ExpProgress from '../ExpProgress'
import CreditProgress from '../CreditProgress'
import NewMedals from '../NewMedals'
import NewTitles from '../NewTitles'
import * as route from '../../../routes'

const styles = {
  root: {
    backgroundColor: '#F7F7F7',
    textAlign: 'center',
  },
  gif: {
    width: '250px',
    height: 'auto',
  },
}

class EarnedForWinning extends React.Component {

  finishMission = () => {
    console.log('Mission finished')
  }

  winInformation = () => {
    if (this.props.needs_revision) {
      return <p> Esta misión necesita ser revisada </p>
    }
    return (<div>
      <Row>
        <Col xs="12" md-offset="1" md="5" style={{ minHeight: '50px' }}>
          <ExpProgress />
        </Col>
        <Col xs="12" md="5" style={{ minHeight: '50px' }}>
          <CreditProgress />
        </Col>
      </Row>
      <br />
      <br />
      <Row>
        <Col xs="12" md-offset="1" md="5">
          <NewMedals />
        </Col>
        <Col xs="12" md="5" >
          <NewTitles />
        </Col>
      </Row>
      <br />
    </div>)
  }

  render() {
    return (
      <Panel className="modal-panel" style={styles.root}>
        <h1>
          ¡Misión Completada!
        </h1>
        <img style={styles.gif} src={FinishGif} alt="¡Felicidades!" />
        { this.winInformation() }
        {
          this.props.target === 1
          ? (
            <RaisedButton
              style={{ marginTop: '10px', minWidth: '400px' }}
              onClick={this.props.reviewMission(this.props.campaign, this.props.mission)}
              label="Revisar Respuestas" primary
              onTouchTap={this.finishMission}
            />
          )
          : (
            <RaisedButton
              style={{ marginTop: '10px', minWidth: '400px' }}
              onClick={this.props.selectCampaign(this.props.campaign)}
              label="Cerrar y Continuar" primary
              onTouchTap={this.finishMission}
            />
          )
        }
      </Panel>
    )
  }
}

EarnedForWinning.propTypes = {
  campaign: React.PropTypes.shape({
    id: React.PropTypes.number,
  }),
  selectCampaign: React.PropTypes.func,
  needs_revision: React.PropTypes.bool,
  target: React.PropTypes.bool,
  reviewMission: React.PropTypes.func,
  id: React.PropTypes.string,
}

const mapStateToProps = state => ({
  ...state.missions.selectedMission,
  campaign: state.campaigns.selectedCampaign,
  mission: state.missions.selectedMission,
  needs_revision: state.missions.answerMission.progress.needs_revision,
  target: state.missions.answerMission.progress.target,
  id: state.missions.answerMission.progress.target,
})

const mapDispatchToProps = dispatch => ({
  selectCampaign: campaign => () =>
    dispatch(selectCampaign(campaign)),
  reviewMission: (campaign, mission) => () =>
    dispatch(push(route.mission_review_path(campaign, mission))),
})

export default connect(mapStateToProps, mapDispatchToProps)(EarnedForWinning)



// WEBPACK FOOTER //
// ./src/components/MissionFinish/EarnedForWinning/index.jsx